module.exports = __webpack_public_path__ + "static/media/fractalTree.660c7ae8.mp4";